import React from 'react'
import { GridToolbarContainer, GridToolbarExport, GridToolbarFilterButton } from '@mui/x-data-grid-pro'
import { Button } from '@mui/material'
import RefreshIcon from '@mui/icons-material/Refresh'
import { type GridCsvExportOptions } from '@mui/x-data-grid/models/gridExport'
import { type GridExportDisplayOptions } from '@mui/x-data-grid/components/toolbar/GridToolbarExport'

export interface FilterExportGridToolbarProps {
  handleReload: () => any
  csvOptions?: GridCsvExportOptions & GridExportDisplayOptions
}

const ReloadFilterExportGridToolbar: React.FC<FilterExportGridToolbarProps> = ({ handleReload, csvOptions }) => {
  return (
    <GridToolbarContainer sx={{ display: 'flex', flexDirection: 'row', paddingX: 1 }}>
      <Button
        startIcon={<RefreshIcon/>}
        onClick={() => {
          handleReload()
        }}
      >
        Reload
      </Button>
      <GridToolbarFilterButton/>
      <GridToolbarExport csvOptions={csvOptions}/>
    </GridToolbarContainer>
  )
}

export default ReloadFilterExportGridToolbar
